import { Identifiable, Planzone, WbsConfiguration } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateWbsConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: WbsConfiguration,
    nextConfiguration: WbsConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: { wbsViewConfigurations: JSON.stringify(nextConfiguration) },
      },
    });
}

export { updateWbsConfiguration };
